/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Autocomplete, MenuItem, Select, FormControl, FormHelperText } from "@mui/material";
import style from "./FormModal.module.css";

import Indian_states_cities_list from "indian-states-cities-list";
import toast from "react-hot-toast";

const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const FormModal = ({
  accept,
  setSelectedCategory,
  isOpen,
  onClose,
  onSubmit,
  fields,
  resetFormData,
  header,
  initialData,
  isEditing,
}) => {
  const initialFormData = {};
  const initialErrors = {};
  fields.forEach((field) => {
    initialFormData[field.name] = field.isMultiSelect ? [] : "";
    initialErrors[field.name] = "";
  });
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState(initialErrors);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  // console.log(Indian_states_cities_list.STATE_WISE_CITIES.Haryana)

  useEffect(() => {
    if (initialData) {
      const updatedFormData = { ...initialFormData };
      Object.keys(initialData).forEach((key) => {
        updatedFormData[key] = initialData[key];
      });
      fields.forEach((field) => {
        if (field.type === "date" && initialData[field.name]) {
          updatedFormData[field.name] = new Date(initialData[field.name])
            .toISOString()
            .split("T")[0];
        }
      });
      setFormData(updatedFormData);
    } else {
      setFormData(initialFormData);
    }
  }, [initialData]);

  const validateFormData = () => {
    const newErrors = {};

    fields.forEach((field) => {
      // if(field.name=='category' || 'subCategory') {
      //   return;
      // }
      // console.log(">>>>>>", formData[field.name], field.name)
      const isEmpty = !formData[field.name];
      const isEditingFileField = field.type === "file" && isEditing;
      const isFileEmpty = isEditingFileField && !formData[field.name]?.name && !initialData[field.name];
      const hasExistingFile = isEditingFileField && initialData[field.name];

      // Only validate required fields, don't show errors for file fields on form load
      if (field.required && field.type !== "file" && isEmpty) {
        newErrors[field.name] = `${field.label} is required`;
      } else if (field.required && field.type === "file") {
        // For file fields, only validate if user has interacted or is submitting
        const hasInteracted = formData[field.name]?.name || (isEditing && initialData[field.name]);
        if (!hasInteracted) {
          newErrors[field.name] = ""; // Don't show error on form load
        } else if (isEmpty && !initialData[field.name]) {
          newErrors[field.name] = `${field.label} is required`;
        }
      } else {
        newErrors[field.name] = "";
      }

      // Trim the field value if it's a string before validation
      if (typeof formData[field.name] === 'string') {
        formData[field.name] = formData[field.name].trim();
      }
      if (
        field.name === "phone" &&
        formData[field.name] &&
        !/^\d{10}$/.test(formData[field.name])
      ) {
        newErrors[field.name] = "Phone number must be exactly 10 digits.";
      }
      if (
        field.name === "email" &&
        formData[field.name] &&
        !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData[field.name])
      ) {
        newErrors[field.name] = "Please enter a valid email address.";
      }
    });

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const handleChange = (fieldName, fieldType) => (event, newValue) => {
    if (Array.isArray(newValue)) {
      setFormData({ ...formData, [fieldName]: newValue });
    } else if (fieldType === "file") {
      const file = event.target.files[0];

      if (file) {
        // Allowed file extensions
        const allowedTypes = ["application/pdf", "image/", "video/"];
        const isValidFileType = allowedTypes.some((type) =>
          file.type.startsWith(type)
        );

        if (!isValidFileType) {
          toast.error("Please upload a PDF, image, or video file.");
          event.target.value = null; // Clear selected file
          return;
        }

        setFormData((prevData) => ({
          ...prevData,
          [fieldName]: file,
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [fieldName]: event.target.value,
      }));
    }

    // Clear error for this field when user starts typing/selecting
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
  };



  const handleSubmit = () => {
    setHasSubmitted(true);
    if (validateFormData()) {
      onSubmit(formData, isEditing, initialData._id);
      onClose();
    }
  };

  const handleCancel = () => {
    const clearedFormData = {};
    fields.forEach((field) => {
      clearedFormData[field.name] = field.isMultiSelect ? [] : "";
    });
    setFormData(clearedFormData);
    setErrors(initialErrors);
    setHasSubmitted(false);
    onClose();
  };

  const handleClose = () => {
    handleCancel();
  };

  useEffect(() => {
    if (resetFormData) {
      setFormData(initialFormData);
      setErrors(initialErrors);
    }
  }, [resetFormData]);

  const getNestedProperty = (obj, path) => {
    const keys = path.split(".");
    let result = obj;

    for (const key of keys) {
      result = result[key];
      if (result === undefined) {
        return "";
      }
    }
    return result;
  };
  const getDropDownValue = (obj, path) => {
    const keys = path.split(".");
    let result = obj;

    for (const key of keys) {
      result = result[key];
      if (result === undefined) {
        return "";
      }
    }
    return result?._id;
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
        className={style.main_div}
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h5"
            component="h2"
            align="center"
            style={{ textDecoration: "underline" }}
          >
            {header}
          </Typography>
        </Box>
        <form>
          <div style={{ margin: "1rem 0" }}>
            {fields.map((field) => {
              let fieldname = field.name;
              return (
                <div key={field.name} style={{ marginBottom: "10px" }}>
                  <Typography>
                    {field.label}
                    {field.required && (
                      <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                    )}
                  </Typography>
                  {field.isMultiSelect ? (
                    <Autocomplete
                      disabled={field.disabled ? true : false}
                      disablePortal
                      id={field.name}
                      options={field.options}
                      value={formData[field.name]}
                      onChange={handleChange(field.name)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={`Select ${field.label}`}
                          error={!!errors[field.name]}
                          helperText={errors[field.name]}
                        />
                      )}
                    />
                  ) : field.type === "option" ? (
                    <FormControl fullWidth error={!!errors[field.name]} disabled={field.disabled}>
                      <Select
                        label={field.label}
                        id={field.name}
                        name={field.name}
                        value={formData[field.name] ?? ""}
                        onChange={(event) => handleChange(field.name)(event)}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return `Select ${field.label}`;
                          }
                          const selectedOption = field.options.find(
                            (option) =>
                              option.value === selected || option === selected
                          );
                          return selectedOption?.label || selectedOption || selected;
                        }}
                      >
                        <MenuItem value="" disabled>
                          {`Select ${field.label}`}
                        </MenuItem>
                        {field.options.map((option) => (
                          <MenuItem key={option.value || option} value={option.value || option}>
                            {option.label || option}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors[field.name] && (
                        <FormHelperText>{errors[field.name]}</FormHelperText>
                      )}
                    </FormControl>
                  ) : field.type === "category" ? (
                    <FormControl fullWidth error={!!errors[field.name]} disabled={field.disabled}>
                      <Select
                        label={field.label}
                        id={field.name}
                        name={field.name}
                        defaultValue={formData.category?._id}
                        value={
                          getDropDownValue(formData, field.name) ??
                          formData[field.name]
                        }
                        onChange={(event) => {
                          handleChange(field.name)(event);
                          setSelectedCategory(event.target.value);
                        }}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          {`Select ${field.label}`}
                        </MenuItem>
                        {field.options.map((option) => (
                          <MenuItem
                            key={option._id || option.value}
                            value={option._id || option.value}
                            disabled={option.disabled || false}
                          >
                            {option.title || option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors[field.name] && (
                        <FormHelperText>{errors[field.name]}</FormHelperText>
                      )}
                    </FormControl>
                  ) : field.type === "subCategory" ? (
                    <FormControl fullWidth error={!!errors[field.name]} disabled={field.disabled}>
                      <Select
                        label={field.label}
                        id={field.name}
                        name={field.name}
                        value={
                          getDropDownValue(formData, field.name) ??
                          formData[field.name]
                        }
                        onChange={(event) => {
                          handleChange(field.name)(event);
                        }}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          {`Select ${field.label}`}
                        </MenuItem>
                        {field.options.map((option) => (
                          <MenuItem
                            key={option._id || option.value}
                            value={option._id || option.value}
                            disabled={option.disabled || false}
                          >
                            {option.title || option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors[field.name] && (
                        <FormHelperText>{errors[field.name]}</FormHelperText>
                      )}
                    </FormControl>
                  ) : field.type === "typography" ? (
                    <TextField
                      // label={field.label}
                      type={field.type}
                      id={field.name}
                      name={field.name}
                      value={getDropDownValue(formData, fieldname)}
                      onChange={(event) => handleChange(field.name)(event)}
                      fullWidth
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                      disabled={field.disabled ? field.disabled : false}
                    />
                  ) : field.type === "description" ? (
                    <TextField
                      // label={field.label}
                      multiline
                      rows={7}
                      type={field.type}
                      id={field.name}
                      name={field.name}
                      value={getNestedProperty(formData, fieldname)}
                      onChange={(event) => handleChange(field.name)(event)}
                      fullWidth
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                      disabled={field.disabled ? field.disabled : false}
                    />
                  ) : field.type === "file" ? (
                    <>
                      <div style={{ marginBottom: '10px' }}>
                        <Typography variant="body2" color="textSecondary" gutterBottom>
                          {field.label}
                          {field.required && (
                            <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                          )}
                        </Typography>
                      </div>
                      <input
                        type="file"
                        accept={accept}
                        onChange={(event) =>
                          handleChange(field.name, field.type)(event)
                        }
                        style={{
                          display: 'none'
                        }}
                        id={`file-input-${field.name}`}
                      />
                      <label htmlFor={`file-input-${field.name}`}>
                        <Button
                          variant="outlined"
                          component="span"
                          sx={{
                            marginBottom: '10px',
                            textTransform: 'none',
                            borderColor: hasSubmitted && errors[field.name] ? 'red' : 'inherit',
                            color: hasSubmitted && errors[field.name] ? 'red' : 'inherit'
                          }}
                        >
                          {formData[field.name]?.name || (isEditing && initialData[field.name] ? 'Change File' : 'Choose File')}
                        </Button>
                      </label>
                      {/* Show existing image preview when editing */}
                      {isEditing && initialData[field.name] && !formData[field.name]?.name && (
                        <div style={{ marginTop: '10px' }}>
                          <Typography variant="body2" color="textSecondary" gutterBottom>
                            Current {field.label}:
                          </Typography>
                          <img
                            src={initialData[field.name]}
                            alt={field.label}
                            style={{
                              maxWidth: '100px',
                              maxHeight: '100px',
                              border: '1px solid #ddd',
                              borderRadius: '4px'
                            }}
                          />
                        </div>
                      )}
                      {/* Show new file preview when selected */}
                      {formData[field.name]?.name && (
                        <div style={{ marginTop: '10px' }}>
                          <Typography variant="body2" color="textSecondary" gutterBottom>
                            New {field.label}:
                          </Typography>
                          {formData[field.name].type.startsWith('image/') ? (
                            <img
                              src={URL.createObjectURL(formData[field.name])}
                              alt="Preview"
                              style={{
                                maxWidth: '100px',
                                maxHeight: '100px',
                                border: '1px solid #ddd',
                                borderRadius: '4px'
                              }}
                            />
                          ) : (
                            <Typography variant="body2">
                              {formData[field.name].name}
                            </Typography>
                          )}
                        </div>
                      )}
                      {/* Only show error if user has submitted the form */}
                      {hasSubmitted && errors[field.name] && (
                        <Typography
                          variant="body2"
                          color="error"
                          sx={{
                            marginTop: "0.4rem",
                            fontSize: "0.75rem",
                          }}
                        >
                          {errors[field.name]}
                        </Typography>
                      )}
                    </>
                  ) : field.type === "date" ? (
                    <TextField
                      // label={field.label}
                      type={field.type}
                      id={field.name}
                      name={field.name}
                      value={formData[field.name]}
                      onChange={(event) => handleChange(field.name)(event)}
                      fullWidth
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                      disabled={field.disabled ? field.disabled : false}
                      InputProps={{
                        inputProps: { max: getCurrentDate() },
                      }}
                    />
                  ) : (
                    <>
                      <TextField
                        // label={field.label}
                        type={field.type}
                        id={field.name}
                        name={field.name}
                        value={getNestedProperty(formData, fieldname)}
                        onChange={(event) => handleChange(field.name)(event)}
                        fullWidth
                        error={!!errors[field.name]}
                        helperText={errors[field.name]}
                        disabled={field.disabled ? field.disabled : false}
                        inputProps={
                          field.name === "phone" ? { maxLength: 10 } : {}
                        }
                      />
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </form>
        <Button onClick={handleCancel} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          sx={{ ml: 4 }}
        >
          {isEditing ? "Update" : "Submit"}
        </Button>
      </Box>
    </Modal>
  );
};

export default FormModal;
